"use client"

import UniversityBase from "./UniversityBase"
import DashboardLayout from "@/views/dashboard/DashboardLayout"

export default function UniversityBasePage() {
  return (
    <DashboardLayout>
      <UniversityBase />
    </DashboardLayout>
  )
}
